
export default {
  name: 'SearchVehiclePacks',
  props: {
    count: {
      type: Number,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    prominent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: '',
    }
  },
  computed: {
    selectedVehicle() {
      return this.$store.getters.selected_vehicle
    },
    hint() {
      if (this.prominent) {
        return this.$t('components.searchVehiclePacks.onlyPacks')
      }

      if (this.selectedVehicle) {
        return this.$tc(
          'components.searchVehiclePacks.hiddenExceptVehicle',
          this.count,
          {
            vehicle: `${this.selectedVehicle.brand?.name || ''} ${
              this.selectedVehicle.name
            }`.trim(),
          }
        )
      }

      return this.$tc('components.searchVehiclePacks.hidden', this.count)
    },
  },
  watch: {
    query() {
      this.model = ''
    },
  },
  methods: {
    searchWithModel() {
      const q = `${this.query} ${this.model}`.replace(/\s+/g, ' ').trim()

      this.$router.push({ path: this.$route.path, query: { q } })
    },
  },
}
